import { useMemo } from "react";
import { usePortalProperty } from "../document/use-portal-property";
import {
  parseProductWidgetMapping,
  ProductWidgetMapping
} from "./raffle-ai-types";

export interface RaffleAiConfig {
  productWidgetMapping: ProductWidgetMapping[];
}

function buildConfig(productWidgetMappingStr: string | undefined) {
  const productWidgetMapping = parseProductWidgetMapping(
    productWidgetMappingStr
  );

  if (productWidgetMapping.length === 0) {
    return null;
  }

  return { productWidgetMapping };
}

export function useRaffleAiConfig() {
  const { value: productWidgetMappingStr, status: mappingStatus } =
    usePortalProperty<string>("RaffleAiProductWidgetMapping");

  const configIsLoaded = mappingStatus !== "success";

  const config = useMemo(() => {
    if (configIsLoaded) {
      return null;
    }
    return buildConfig(productWidgetMappingStr);
  }, [configIsLoaded, productWidgetMappingStr]);

  return config;
}
